import { FrameSourceState, SingleImageUploader } from '@scandit/web-datacapture-core'
import type AppStore from './AppStore'
import { signal, Signal } from '@preact/signals'

export type TSingleImageModeStore = {
  enable: () => Promise<void>
  enabled: Signal<boolean>
}

const SingleImageModeStore = (appStore: AppStore): TSingleImageModeStore => {
  const enabled = signal(false)
  return {
    async enable() {
      await appStore.sdk!.context?.setFrameSource(SingleImageUploader.default)
      await appStore.sdk!.context?.frameSource?.switchToDesiredState(FrameSourceState.On)
      await appStore.sdk!.barcodeCaptureMode?.setEnabled(true)
      enabled.value = true
    },
    enabled,
  }
}

export default SingleImageModeStore
